/* ============================================================
   LokiTweaks — GLOBAL STOREFRONT BEHAVIOR v26
   Nuclear grid fix: setInterval loop + direct inline styles.
   ============================================================ */
(function () {
  'use strict';
  if (window.__lokiGlobalLoaded) return;
  window.__lokiGlobalLoaded = true;

  var GRID_COLS = 'repeat(5, minmax(0, 1fr))';

  /* ---- Force grid columns via inline style on EVERY matching element ---- */
  function forceGrid() {
    // Target ALL possible grid containers
    var sels = [
      '[data-testid="product-grid"]',
      'ul.product-grid',
      'div.product-grid',
      '.product-grid--grid',
      '.product-grid--organic',
      '.product-grid'
    ];
    var seen = {};
    sels.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var key = el.className || el.tagName;
        if (seen[key]) return;
        seen[key] = true;
        // Set grid-template-columns directly via inline style
        el.style.setProperty('grid-template-columns', GRID_COLS, 'important');
        el.style.setProperty('--product-grid-columns-desktop', GRID_COLS, 'important');
        el.style.setProperty('--resource-card-aspect-ratio', '4 / 5', 'important');
      });
    });
  }

  /* ---- Force uniform card images ---- */
  function forceCards() {
    // Media containers
    document.querySelectorAll(
      '.resource-card__media, .card__media, .card-media, ' +
      '.product-card__image-wrapper, .resource-card__media-wrapper, ' +
      '.product-media-container, .product-grid .product-media'
    ).forEach(function (el) {
      el.style.setProperty('aspect-ratio', '4 / 5', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
      el.style.setProperty('width', '100%', 'important');
    });
    // Images inside cards
    document.querySelectorAll(
      '.resource-card__media img, .card__media img, .card-media img, ' +
      '.product-card__image-wrapper img, .resource-card__media-wrapper img, ' +
      '.product-media-container img, .product-grid .product-media img, ' +
      '.product-grid img'
    ).forEach(function (img) {
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('height', '100%', 'important');
      img.style.setProperty('object-fit', 'cover', 'important');
      img.style.setProperty('object-position', 'center', 'important');
      img.style.setProperty('display', 'block', 'important');
    });
  }

  /* ---- Gallery fallback ---- */
  function ensureGalleryImage() {
    var g = document.querySelector('media-gallery, .media-gallery, .product-media-gallery');
    if (!g || g.querySelector('.ltx-gallery-img')) return;
    var img = g.querySelector('.product-media__image, .product-media img, img[data_max_resolution]');
    if (!img) return;
    var src = img.getAttribute('data_max_resolution') || img.currentSrc || img.src;
    if (!src) return;
    if (src.indexOf('//') === 0) src = location.protocol + src;
    var clone = document.createElement('img');
    clone.className = 'ltx-gallery-img';
    clone.src = src;
    clone.alt = img.alt || '';
    clone.loading = 'eager';
    clone.style.cssText = 'pointer-events:none;position:absolute;inset:0;width:100%;height:100%;object-fit:contain;z-index:1;';
    g.style.position = 'relative';
    g.appendChild(clone);
  }

  /* ---- Cart attention pulse ---- */
  function cartAttention() {
    if (sessionStorage.getItem('ltx_cart_attn')) return;
    var cart = document.querySelector('[href*="/cart"], .cart-link, .header__icon--cart');
    if (!cart) return;
    cart.classList.add('ltx-cart-attn');
    sessionStorage.setItem('ltx_cart_attn', '1');
    setTimeout(function () { cart.classList.remove('ltx-cart-attn'); }, 5000);
  }

  /* ---- Apply everything ---- */
  function applyAll() {
    forceGrid();
    forceCards();
    ensureGalleryImage();
  }

  function onReady() {
    cartAttention();
    applyAll();

    // setInterval: continuously force grid for 10 seconds (catches theme JS resets)
    var count = 0;
    var iv = setInterval(function () {
      applyAll();
      count++;
      if (count >= 20) clearInterval(iv); // ~10 sec at 500ms
    }, 500);

    // Also run at key intervals as safety nets
    [100, 300, 600, 1000, 2000, 3000, 5000, 8000].forEach(function (ms) {
      setTimeout(applyAll, ms);
    });

    // MutationObserver: catch any style/class resets on the grid
    if (window.MutationObserver) {
      var observeGrid = function () {
        document.querySelectorAll(
          '[data-testid="product-grid"], ul.product-grid, div.product-grid, .product-grid'
        ).forEach(function (grid) {
          if (grid._ltxObserved) return;
          grid._ltxObserved = true;
          new MutationObserver(function () {
            forceGrid();
            forceCards();
          }).observe(grid, { attributes: true, attributeFilter: ['style', 'class'] });
        });
      };
      observeGrid();
      // Re-check observer setup when DOM changes
      new MutationObserver(observeGrid).observe(document.body, { childList: true, subtree: true });
    }

    // Watch for gallery DOM mutations
    var watchGallery = function () {
      var g = document.querySelector('media-gallery, .media-gallery, .product-media-gallery');
      if (g && !g._ltxGalleryObserved && window.MutationObserver) {
        g._ltxGalleryObserved = true;
        new MutationObserver(function () {
          if (!g.querySelector('.ltx-gallery-img')) ensureGalleryImage();
        }).observe(g, { childList: true, subtree: true });
      }
    };
    watchGallery();
    new MutationObserver(watchGallery).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
  window.addEventListener('load', function () {
    applyAll();
    // Extra burst after full load
    var count = 0;
    var iv2 = setInterval(function () {
      applyAll();
      count++;
      if (count >= 10) clearInterval(iv2);
    }, 300);
  });
  window.addEventListener('resize', forceGrid);
})();
